import React, { useState, useMemo } from 'react';
import { ValidationCheckForm } from './ValidationCheckForm';
import { ValidationCheckResult } from './ValidationCheckResult';

import { ValidationCheckService } from '../../services/validationcheck/ValidationCheckService';
import { ValidationCheckRepository } from '../../repositories/validationcheck/ValidationCheckRepository';

function ValidationCheckPage() {
  const [resultado, setResultado] = useState(null);
  const [summary, setSummary] = useState(null);
  const [erro, setErro] = useState(null); 
  const [carregando, setCarregando] = useState(false);

  const validationCheckRepository = useMemo(() => new ValidationCheckRepository(), []);
  const validationCheckService = useMemo(
    () => new ValidationCheckService(validationCheckRepository), 
    [validationCheckRepository]
  );

  const manipularValidacao = async (dadosCliente) => {
    setCarregando(true);

    try {
      const customers = await validationCheckService.validarCliente(dadosCliente);

      console.log(customers)
      setResultado(customers);
      setErro(null); 
    } catch (erro) {
      console.error('Erro na validação:', erro);
      setErro(erro.message || 'Erro inesperado na validação');
      setResultado([]);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="app-container">
      <h1>Validação de Candidatos</h1>

      <ValidationCheckForm onSubmit={manipularValidacao} />

      {/* Alerta de erro */}
      {erro && (
        <div className="alerta-erro">
          <strong>Erro:</strong> {erro}
        </div>
      )}

      {carregando && (
        <div className="overlay-loading">
          <div className="spinner" />
          <p>Processando validação, por favor aguarde...</p>
        </div>
      )}

      {resultado !== null && <ValidationCheckResult customers={resultado} />}
    </div>
  );
}

export default ValidationCheckPage;
